import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Components
import { InfoMainDiv, InfoButton, InfoText, InfoArrowImg, IndicatorDiv } from "./styles";
// Assets
import ArrowDown from "../../../../assets/ico_arrow_down_black.svg";
import ArrowUp from "../../../../assets/ico_arrow_up_black.svg";

const ProtocolInfo = () => {
  const [isShowInfo, setIsShowInfo] = useState(false);
  const [t] = useTranslation("global");

  const handleShowInfo = (e) => {
    e.preventDefault();
    setIsShowInfo(!isShowInfo);
  };

  return (
    <InfoMainDiv>
      <InfoButton onClick={handleShowInfo}>
        <InfoText>{t("informationButton.title")}</InfoText>
        <InfoArrowImg src={isShowInfo ? ArrowUp : ArrowDown} alt="arrow" />
      </InfoButton>
      <IndicatorDiv display={isShowInfo ? "flex" : "none"}>
        <InfoText>{t("prescriptions.prescriptionsIndication")}</InfoText>
        <InfoText>{t("prescriptions.reportsIndication")}</InfoText>
      </IndicatorDiv>
    </InfoMainDiv>
  );
};

export default ProtocolInfo;
